import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import "./launch.css"; // For styling
import logo from "../../images/logo_bg.png"; // Import your logo

const LaunchPage = () => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  // useEffect(() => {
  //   setTimeout(() => {
  //     setLoading(false); // Simulate loading completion
  //   }, 3000); // Loading time (3 seconds)
  // }, []);

  const handleRedirect = () => {
    history.push("/home");
  };

  return (
    <div className="launchbody">
      <div className="content">
        <img src={logo} alt="Logo" className="logo" />
        <div className="loading-container">
          <div className="loading-text">
            <span>L</span>
            <span>O</span>
            <span>A</span>
            <span>D</span>
            <span>I</span>
            <span>N</span>
            <span>G</span>
          </div>
        </div>
        {!loading && (
          <button
            className={`arrow-button ${!loading ? "show" : ""}`}
            onClick={handleRedirect}
          >
            → Launch
          </button>
        )}
      </div>
    </div>
  );
};

export default LaunchPage;
